export const IncreaseIcon = ({ size = 12, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M3.5 3.5H8.5V8.5"
      stroke="#0E966F"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5 8.5L8.5 3.5"
      stroke="#0E966F"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
